import { render, staticRenderFns } from "./WorkspaceTabs.vue?vue&type=template&id=3b170237&scoped=true"
import script from "./WorkspaceTabs.vue?vue&type=script&lang=js"
export * from "./WorkspaceTabs.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceTabs.vue?vue&type=style&index=0&id=3b170237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b170237",
  null
  
)

export default component.exports